module.exports = __webpack_public_path__ + "img/wolf.87f8bd59.svg";